export default __webpack_public_path__ + "static/banner-what-is-involved-in-getting-a-car-loan-5c2e1150dc2a6ff21da86e7bd7185261.jpg";